import React, { Component } from "react";
import PendingTab from "./pendingTab";
import In_progressTab from "./in-progressTab";
import CompletedTab from "./completedTab";
class PostAuthWorklist extends Component {
    constructor(props){
        super();
        this.state = {
            currentTab: "pending-tab"
        }
    }

    componentDidMount() {
        let active_page = JSON.parse(localStorage.getItem("PostAuth_active_tab"));
        active_page = active_page ? active_page : "pending-tab"
        this.onselectTab(active_page)
    }

    onselectTab = (value) => {
        localStorage.setItem("PostAuth_active_tab", JSON.stringify(value));
        this.setState({currentTab: value}, () => clearInterval())
    }

    render(){
        const {currentTab, } = this.state
        const tabs = [
            {
                id: 'pending-tab',
                key: 'pending',
                label: 'Pending',
            },
            {
                id: 'in-progress-tab',
                key: 'in-progress',
                label: 'In Progress',
            },
            {
                id: 'completed-tab',
                key: 'completed',
                label: 'Completed',
            },
        ]
        return (
            <React.Fragment>
                <div className="container-fluid lg-container pl-3 py-2">
                    <ul class="nav nav-tabs" id="nav-tab" role="tablist">
                        {tabs.map((tab, key) =>  
                            <li class="nav-item mr-2" role="presentation" style={{marginBottom:"-2px"}}>
                                <button 
                                    class={`py-2 nav-link ${currentTab === tab.id ? "active border-bottom-0" : ""}`} 
                                    onClick={() => this.onselectTab(tab.id)} 
                                    // style={{width: "180px", borderColor: currentTab === tab.id ? "#1e74ad":"#f0f0f0", outline: 'none', backgroundColor: currentTab === tab.id ? "rgb(243, 244, 248)" : "#fff", color: currentTab === tab.id && "#1e74ad"}} 
                                    style={{width: "180px", borderColor: "#1e74ad #1e74ad #fff #1e74ad", outline: 'none', backgroundColor: currentTab === tab.id ? "#1e74ad" : "#f0f0f0", color: currentTab === tab.id && "#fff"}} 
                                    id={`${tab.id}`} 
                                    data-bs-toggle="tab" 
                                    data-bs-target={`#${tab.id}`} 
                                    type="button" 
                                    role="tab" 
                                    aria-controls={`${tab.id}`} 
                                    aria-selected="true"
                                >
                                    {tab.label}
                                </button>
                            </li>
                        )}
                    </ul>
                    <div class="tab-content">
                        <div className="card rounded-0" style={{background: "rgb(243, 244, 248)"}}>
                        {currentTab === "pending-tab" ? (
                            <div className="tab-pane fade show active" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                                <PendingTab {...this.props} />
                            </div>
                        ) : currentTab === "in-progress-tab" ? (
                            <div className="tab-pane fade show active" id="in-progress" role="tabpanel" aria-labelledby="in-progress-tab">
                                <In_progressTab {...this.props} />
                            </div>
                        ) : (
                            <div className="tab-pane fade show active" id="completed" role="tabpanel" aria-labelledby="completed-tab">
                                <CompletedTab {...this.props} />
                            </div>
                        )}

                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default PostAuthWorklist;